// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__AGotP","padded":"styles_padded__IqQp2"};